
<map-marker #marker="mapMarker" #markerElementRef
    [position]="markerPosition" 
    [options]="markerOptions" 
    [attr.data-site-id]="site?.Identifier"
    (mapClick)="onMarkerClick($event, marker, markerElementRef)">
</map-marker>
